import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronHollowRight = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 30C9.794 30 8 28.206 8 26C8 24.932 8.416 23.927 9.171 23.172L16.343 16L9.171 8.829C8.416 8.073 8 7.069 8 6C8 3.794 9.794 2 12 2C13.068 2 14.073 2.416 14.828 3.171L24.828 13.171C25.584 13.926 25.999 14.931 25.999 16C25.999 17.069 25.583 18.073 24.827 18.828L14.827 28.828C14.071 29.584 13.067 30 11.998 30H12ZM12 4C10.897 4 10 4.897 10 6C10 6.534 10.208 7.036 10.586 7.414L18.465 15.292C18.855 15.683 18.855 16.316 18.465 16.706L10.586 24.585C10.208 24.963 10 25.465 10 25.999C10 27.102 10.897 27.999 12 27.999C12.534 27.999 13.036 27.791 13.414 27.413L23.414 17.413C23.792 17.035 24 16.533 24 15.999C24 15.465 23.792 14.962 23.414 14.585L13.414 4.585C13.036 4.207 12.534 3.999 12 3.999V4Z" />
	</svg>
);

export default ChevronHollowRight;
